import yup from './yup'
import moment from 'moment'

export const talkFormSchema = yup
  .object()
  .shape({
    eventId: yup.string().nullable(),
    sessionId: yup.string().nullable(),
    title: yup.string().label('Title').trimmedRequired('Poster/Talk Title is required'),
    venueId: yup.string().required('Building is required'),
    startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
    endDate: yup
      .date()
      .label('End date')
      .typeError('Invalid date')
      .test('Date Check', 'End date must be after start date.', function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate, 'date')
      })
      .test('Time Check', 'End Time must be after start Time.', function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate)
      })
      .required(),
    moderators: yup.array().label('Moderators').nullable(),
    speakers: yup.array().label('Speakers').nullable(),
    sponsors: yup.array().label('Sponsors').nullable(),
    havePolls: yup.string().oneOf(['yes', 'no']),
    isAbstract: yup.boolean().label('Abstract Number'),
    posterNumber: yup.number().label('Poster number').required(),
    abstractNumber: yup.number().label('Abstract number').required()
  })
  .test('at-least-one', 'Please select an event or sub-event', function (value) {
    const { eventId, sessionId } = value || {}
    return !!eventId || !!sessionId
  })
